module.exports = __webpack_public_path__ + "img/finland.2f071be0.svg";